import { Controller } from "stimulus";
import tippy from "tippy.js";
import 'tippy.js/themes/light-border.css';
import '../styles/partials/_card-menu.scss';
import AjaxLoader from "../entrypoints/src/admin/utilities/ajax-loader";

export default class extends Controller {
  static targets = [
    'agenda',
    'form',
    'inputDate'
  ];

  connect() {
    this.initializeBase();
    this.initializeCardProperties();
  }

  initializeBase() {
    AjaxLoader.hide();
    this.adjustCalendar();

    $('.submit-form').on('change', (ev) => this.submitForm(ev));
    this.element.querySelectorAll('.toggle-filter').forEach(($el) => { $el.addEventListener('click', (ev) => this.element.querySelector('.filters').classList.toggle('in')) });
    this.element.querySelectorAll('a.date').forEach(($a) => {
      $a.addEventListener('click', (ev) => {
        ev.stopPropagation();
        ev.preventDefault();
        this.inputDateTarget.value = $a.dataset.date;
        this.submitForm();
      });
    });
  }

  initializeCardProperties() {
    this.element.querySelectorAll('.card').forEach((card) => {
      tippy(card, {
        content: this.cardMenu(card),
        trigger: 'click', // mouseenter, click, focus; manual.
        placement: 'bottom',
        appendTo: document.body,
        arrow: true,
        allowHTML: true,
        theme: 'light-border',
        animation: 'scale',
        duration: [250, 200],
        interactive: true,
        delay: [225, 200],
        onShown: (instance) => {
          document.querySelectorAll('.c-card a.c-card__menu-item').forEach(($a) => {
            $a.addEventListener('click', (event) => this.element.querySelectorAll('.card.open').length > 0 && document.querySelector('.schedule-mask').click());
          });
        }
      });
    });

    $('body').on('click', '.c-card a.c-card__menu-item', (ev) => {
      let $a = ev.currentTarget,
        tippyRoot = $a.closest('[data-tippy-root]');

      !!tippyRoot && tippyRoot._tippy.hide();
      this.element.querySelectorAll('.card.open').length > 0 && document.querySelector('.schedule-mask').click();
    });
  }

  cardMenu(card) {
    return `
      <div class="c-card">
        ${card.dataset.menuItems}
      </div>
    `;
  }

  submitForm() {
    AjaxLoader.show();
    this.formTarget.insertAdjacentHTML('afterBegin', '<button id="submit-button" class="d-none"></button>');
    this.formTarget.querySelector('#submit-button').click();
  }

  adjustCalendar() {
    if (window.matchMedia("(max-width: 576px)").matches) {
      return;
    }

    let panelScroll = this.element.querySelector('.filters');

    panelScroll.style.height = `calc(100vh - ${panelScroll.getBoundingClientRect().y + 2}px - ${document.querySelector('.tr-footer').clientHeight}px)`;

    $(panelScroll).on('scroll', (ev) => {
      panelScroll.closest('.side-panel-container').classList.toggle('scrolled', panelScroll.scrollTop > 0);
    });
  }
}